import { Chip, ChipProps, SxProps, Theme, useTheme } from "@mui/material";
import { ReactNode, useMemo } from "react";
type StatusChipProps = {
  status: "active" | "deactivated";
  activeLabel?: ReactNode;
  deactiveLabel?: ReactNode;
  chipProps?: ChipProps;
  hideActive?: boolean;
};
const borderRadius = "16px";

export const StatusChip = (props: StatusChipProps) => {
  const theme = useTheme();

  const sxStatusChip: SxProps<Theme> = useMemo(() => {
    return {
      ...props.chipProps?.sx,
      borderRadius: borderRadius,
      minWidth: "50px",
      fontSize: theme.typography.body1,
    };
  }, [props.chipProps, theme.typography.body1]);
  return (
    <>
      {props.status === "active" ? (
        props.hideActive ? (
          <></>
        ) : (
          <Chip
            {...props.chipProps}
            label={props.activeLabel ? props.activeLabel : "Đang hoạt động"}
            sx={{
              ...sxStatusChip,
              backgroundColor: "#D4FDDC",
              minWidth: "50px",
              span: {
                color: "#024C0C",
              },
            }}
          ></Chip>
        )
      ) : (
        <Chip
          {...props.chipProps}
          label={props.deactiveLabel ? props.deactiveLabel : "Không hoạt động"}
          sx={{
            ...sxStatusChip,
            backgroundColor: "#F4F4F4",
            minWidth: "80px",
            span: {
              color: "#535353",
            },
          }}
        ></Chip>
      )}
    </>
  );
};
